import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../castle-kit';
import * as g from '../../castle-kit-grounds';

/**
 * ASTRONOMY TOWER (Звездочётная башня) — the stargazer's chamber at the top of Castle Hearthhold: a tall,
 * narrow, isolated tower built to WATCH THE NIGHT, so it is kept deliberately spare.
 *
 * Composition: the great brass TELESCOPE is the unmistakable HERO, standing on the deep central runner with
 * the astronomy stool tucked under it so the watcher leans to the eyepiece. Two true astronomy accents flank
 * it — a brass ARMILLARY sphere (a model of the heavens) and a LECTERN holding an open star-atlas — both
 * hugging the west wall. A SCROLL-SHELF of star-charts lines the east wall. A celestial TAPESTRY drapes the
 * upper-west wall and a heraldic BANNER crowns the peak. ONE warm CANDELABRA pools just enough light to read
 * by — never enough to drown the sky. Everything else is OPEN FLOOR: empty space is the point, this is a room
 * for looking up. (Removed the crystal orb + potted lily as off-narrative, and thinned 4 stacked lights to 1.)
 *
 * Geometry: zone (3240,40) 320×720 → centre (3400,400). Doors on the WEST wall (rampart y200, library y560)
 * are kept clear; the central vertical spine (x≈3400) stays walkable end to end.
 */
const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art } = ctx;

  // ── Floor: a long deep runner up the tower spine (laid first, under everything). ──
  place(ctx, kit.runnerRug(art, 110, 560), 3400, 400);

  // ── Celestial TAPESTRY on the upper-west wall + heraldic BANNER crowning the peak. ──
  place(ctx, kit.tapestry(art, 90, 120, 'scene'), 3290, 110);
  place(ctx, kit.banner(art, 0x2f4a8a, 90), 3500, 110);

  // ── The astronomy STOOL (sit spot, load-bearing) at (3400,200) + HERO TELESCOPE just north of its gaze. ──
  place(ctx, kit.woodChair(art), 3400, 200);
  place(ctx, g.telescope(art), 3400, 300);

  // ── ONE warm CANDELABRA, set off-spine by the eyepiece so its glow pools on the atlas without washing
  //    out the night the room watches — the room's single light beat. ──
  place(ctx, kit.candelabra(art), 3480, 440);

  // ── Two true astronomy accents against the west wall: the brass ARMILLARY + a star-atlas LECTERN. ──
  place(ctx, g.armillary(art), 3300, 540);
  place(ctx, kit.lectern(art), 3320, 640);

  // ── The SCROLL-SHELF of star-charts down the east wall, anchoring the foot of the tower. ──
  place(ctx, kit.scrollShelf(art, 80, 110), 3490, 600);
};

export default decorate;
